const messages = {
  buttons: {
    productBrochures: "Entdecken",
  },
  index: {
    title: "PRODUKTINFORMATIONEN",
    description:
      "Willkommen im Informationsbereich rund um die Produkte von Bridgestone und Firestone. Hier finden Sie aktuelle Broschüren und weiterführende Materialien.",
    categories: {
      productBrochures: {
        title: "Produktbroschüren",
        description: "Broschüren der Bridgestone- und Firestone-Reifenserien",
      },
      bDrive: {
        title: "Produkt-Abbildungen",
        description: "Aktuelle Abbildungen finden Sie in unserem B-DRIVE Portal zum Download",
        button: "ZU B-DRIVE",
      },
    
      kickback: {
        description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
      },
    },
  },
};

export default {
  messages,
};
